import HRUpdateCourse from "src/components/course/UpdateCourse";

export default function UpdateCourse() {
  return (
    <div className='w-11/12 max-w-7xl mx-auto'>
      <HRUpdateCourse />
    </div>
  );
}
